import { render, staticRenderFns } from "./distributorDeclaration.vue?vue&type=template&id=19a05aa5&scoped=true&"
import script from "./distributorDeclaration.vue?vue&type=script&lang=js&"
export * from "./distributorDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./distributorDeclaration.vue?vue&type=style&index=0&id=19a05aa5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a05aa5",
  null
  
)

export default component.exports